import {Component, OnInit} from '@angular/core';
import {FormBuilder, Validators} from '@angular/forms';
import {HttpClient, HttpErrorResponse} from '@angular/common/http';
import {LoaderService} from '@core/loader.service';
import {NavService} from '@core/nav.service';
import {map} from 'rxjs/operators';


@Component({
  selector: 'app-callback-form',
  template: `
    <container-element [ngSwitch]="formState">
      <div class="animate-switch" *ngSwitchCase="'success'">
        <p style="text-align:center;">Thank you, your message has been sent.</p>
      </div>
      <div *ngSwitchDefault>
        <form class="" [formGroup]="FeedBackGroup" #userFeedbackForm="ngForm" (ngSubmit)="onSubmit()">
          <div fxLayout="row wrap" fxLayoutAlign="space-between start">
            <mat-form-field appearance="outline" fxFlex="100" fxFlex.gt-sm="49">
              <mat-label i18n="callbackForm|form label 1">Name</mat-label>
              <input type="text" matInput formControlName="name">
              <mat-error *ngIf="key.name.invalid">{{getErrorName()}}</mat-error>
            </mat-form-field>
            <mat-form-field appearance="outline" fxFlex="100" fxFlex.gt-sm="49">
              <mat-label i18n="callbackForm|form label 2">Country</mat-label>
              <mat-select formControlName="country" required>
                <mat-option>None</mat-option>
                <mat-option *ngFor="let c of country" [value]="c">{{c}}</mat-option>
              </mat-select>
              <mat-error *ngIf="key.country.invalid">{{getErrorCountry()}}</mat-error>
            </mat-form-field>
            <mat-form-field appearance="outline" fxFlex="100" fxFlex.gt-sm="49">
              <mat-label i18n="callbackForm|form label 3">Enter your Phone</mat-label>
              <input type="text" matInput formControlName="phone" required>
              <mat-error *ngIf="key.phone.invalid">{{getErrorPhone()}}</mat-error>
            </mat-form-field>
            <mat-form-field appearance="outline" fxFlex="100" fxFlex.gt-sm="49">
              <mat-label i18n="callbackForm|form label 4">Enter your Email</mat-label>
              <input type="text" matInput formControlName="email" required>
              <mat-error *ngIf="key.email.invalid">{{getErrorEmail()}}</mat-error>
            </mat-form-field>
            <div fxFlex="100" fxFlex.gt-sm="49" fxLayout="row wrap" fxLayoutAlign="space-between start">
              <p class="call_size_font" i18n="callbackForm|form label 4">Preferred Day to Call:</p>
              <mat-form-field appearance="outline" fxFlex="100">
                <mat-select formControlName="preferredDay" required>
                  <mat-option value="Any Day" i18n="callbackForm|form select 1">Any Day</mat-option>
                  <mat-option value="Monday" i18n="callbackForm|form select 2">Monday</mat-option>
                  <mat-option value="Tuesday" i18n="callbackForm|form select 3">Tuesday</mat-option>
                  <mat-option value="Wednesday" i18n="callbackForm|form select 4">Wednesday</mat-option>
                  <mat-option value="Thursday" i18n="callbackForm|form select 5">Thursday</mat-option>
                  <mat-option value="Friday" i18n="callbackForm|form select 6">Friday</mat-option>
                </mat-select>
                <mat-error *ngIf="key.preferredDay.invalid">{{getErrorCountry()}}</mat-error>
              </mat-form-field>
            </div>
            <div fxFlex="100" fxFlex.gt-sm="49" fxLayout="row wrap" fxLayoutAlign="space-between start">
              <p class="call_size_font" fxFlex="100" i18n="callbackForm|form label 5">Preferred Time (GMT):</p>
              <mat-form-field appearance="outline" fxFlex="49">
                <mat-select formControlName="preferredTimeFrom" required>
                  <mat-option value="Anytime" i18n="callbackForm|form select 7">Anytime</mat-option>
                  <mat-option value="06:00">06:00</mat-option>
                  <mat-option value="07:00">07:00</mat-option>
                  <mat-option value="08:00">08:00</mat-option>
                  <mat-option value="09:00">09:00</mat-option>
                  <mat-option value="10:00">10:00</mat-option>
                  <mat-option value="11:00">11:00</mat-option>
                  <mat-option value="12:00">12:00</mat-option>
                  <mat-option value="13:00">13:00</mat-option>
                  <mat-option value="14:00">14:00</mat-option>
                </mat-select>
                <mat-error *ngIf="key.preferredTimeFrom.invalid">{{getErrorCountry()}}</mat-error>
              </mat-form-field>
              <mat-form-field appearance="outline" fxFlex="49">
                <mat-select formControlName="preferredTimeTo" required>
                  <mat-option value="Anytime" i18n="callbackForm|form select 8">Anytime</mat-option>
                  <mat-option value="07:00">07:00</mat-option>
                  <mat-option value="08:00">08:00</mat-option>
                  <mat-option value="09:00">09:00</mat-option>
                  <mat-option value="10:00">10:00</mat-option>
                  <mat-option value="11:00">11:00</mat-option>
                  <mat-option value="12:00">12:00</mat-option>
                  <mat-option value="13:00">13:00</mat-option>
                  <mat-option value="14:00">14:00</mat-option>
                  <mat-option value="15:00">15:00</mat-option>
                </mat-select>
                <mat-error *ngIf="key.preferredTimeTo.invalid">{{getErrorCountry()}}</mat-error>
              </mat-form-field>
            </div>
            <mat-form-field appearance="outline" fxFlex="100">
              <mat-label i18n="callbackForm|form label 7">Topic</mat-label>
              <mat-select formControlName="topic">
                <mat-option value="General" i18n="callbackForm|form select 9">General</mat-option>
                <mat-option value="Account Inquiry" i18n="callbackForm|form select 10">Account Inquiry</mat-option>
                <mat-option value="Technical Problem/Support" i18n="callbackForm|form select 11">Technical Problem/Support</mat-option>
                <mat-option value="Dealing/Trading Issue" i18n="callbackForm|form select 12">Dealing/Trading Issue</mat-option>
                <mat-option value="Accounting Issue" i18n="callbackForm|form select 13">Accounting Issue</mat-option>
                <mat-option value="Client Request" i18n="callbackForm|form select 14">Client Request</mat-option>
              </mat-select>
              <mat-error *ngIf="key.topic.invalid">{{getErrorCountry()}}</mat-error>
            </mat-form-field>
            <mat-form-field appearance="outline" fxFlex="100">
              <mat-label i18n="callbackForm|form label 8">Topic Details</mat-label>
              <textarea matInput rows="8" formControlName="message"></textarea>
              <mat-error *ngIf="key.message.invalid">{{getErrorMessage()}}</mat-error>
            </mat-form-field>
            <div fxLayout="row wrap" fxLayoutAlign="end start" fxFlex="100">
              <button [disabled]="loader.loading"  class="btn btn_red" i18n="callbackForm|submit button">CONFIRM</button>
            </div>
          </div>
        </form>
      </div>
    </container-element>
  `,
  styles: [
    ``
  ]

})
export class CallbackFormComponent implements OnInit {

  country: string [] = ['Afghanistan', 'Albania', 'Algeria', 'American Samoa', 'Andorra', 'Angola', 'Anguilla', 'Antarctica', 'Antigua and Barbuda', 'Argentina', 'Armenia', 'Aruba', 'Australia', 'Austria', 'Azerbaijan', 'Bahamas', 'Bahrain', 'Bangladesh', 'Barbados', 'Belarus', 'Belgium', 'Belize', 'Benin', 'Bermuda', 'Bhutan', 'Bolivia', 'Bosnia and Herzegowina', 'Botswana', 'Bouvet Island', 'Brazil', 'British Indian Ocean Terr.', 'Brunei Darussalam', 'Bulgaria', 'Burkina Faso', 'Burundi', 'Cambodia', 'Cameroon', 'Canada', 'Cape Verde', 'Cayman Islands', 'Central African Republic', 'Chad', 'Chile', 'China', 'Christmas Island', 'Cocos (Keeling) Islands', 'Colombia', 'Comoros', 'Congo', 'Cook Islands', 'Costa Rica', 'Cote d\'Ivoire', 'Croatia (Hrvatska)', 'Cuba', 'Cyprus', 'Czech Republic', 'Denmark', 'Djibouti', 'Dominica', 'Dominican Republic', 'East Timor', 'Ecuador', 'Egypt', 'El Salvador', 'Equatorial Guinea', 'Eritrea', 'Estonia', 'Ethiopia', 'Falkland Islands/Malvinas', 'Faroe Islands', 'Fiji', 'Finland', 'France', 'France, Metropolitan', 'French Guiana', 'French Polynesia', 'French Southern Terr.', 'Gabon', 'Gambia', 'Georgia', 'Germany', 'Ghana', 'Gibraltar', 'Greece', 'Greenland', 'Grenada', 'Guadeloupe', 'Guam', 'Guatemala', 'Guinea', 'Guinea-Bissau', 'Guyana', 'Haiti', 'Heard &amp; McDonald Is.', 'Honduras', 'Hong Kong', 'Hungary', 'Iceland', 'India', 'Indonesia', 'Iran', 'Iraq', 'Ireland', 'Israel', 'Italy', 'Jamaica', 'Japan', 'Jordan', 'Kazakhstan', 'Kenya', 'Kiribati', 'Korea, North', 'Korea, South', 'Kuwait', 'Kyrgyzstan', 'Lao People\'s Dem. Rep.', 'Latvia', 'Lebanon', 'Lesotho', 'Liberia', 'Libyan Arab Jamahiriya', 'Liechtenstein', 'Lithuania', 'Luxembourg', 'Macau', 'Macedonia', 'Madagascar', 'Malawi', 'Malaysia', 'Maldives', 'Mali', 'Malta', 'Marshall Islands', 'Martinique', 'Mauritania', 'Mauritius', 'Mayotte', 'Mexico', 'Micronesia', 'Moldova', 'Monaco', 'Mongolia', 'Montserrat', 'Morocco', 'Mozambique', 'Myanmar', 'Namibia', 'Nauru', 'Nepal', 'Netherlands', 'Netherlands Antilles', 'New Caledonia', 'New Zealand', 'Nicaragua', 'Niger', 'Nigeria', 'Niue', 'Norfolk Island', 'Northern Mariana Is.', 'Norway', 'Oman', 'Pakistan', 'Palau', 'Panama', 'Papua New Guinea', 'Paraguay', 'Peru', 'Philippines', 'Pitcairn', 'Poland', 'Portugal', 'Puerto Rico', 'Qatar', 'Reunion', 'Romania', 'Russian Federation', 'Rwanda', 'Saint Kitts and Nevis', 'Saint Lucia', 'St. Vincent &amp; Grenadines', 'Samoa', 'San Marino', 'Sao Tome &amp; Principe', 'Saudi Arabia', 'Senegal', 'Seychelles', 'Sierra Leone', 'Singapore', 'Slovakia (Slovak Republic)', 'Slovenia', 'Solomon Islands', 'Somalia', 'South Africa', 'S.Georgia &amp; S.Sandwich Is.', 'Spain', 'Sri Lanka', 'St. Helena', 'St. Pierre &amp; Miquelon', 'Suriname', 'Svalbard &amp; Jan Mayen Is.', 'Swaziland', 'Sweden', 'Switzerland', 'Syrian Arab Republic', 'Taiwan', 'Tajikistan', 'Tanzania', 'Thailand', 'Togo', 'Tokelau', 'Tonga', 'Trinidad and Tobago', 'Tunisia', 'Turkmenistan', 'Turks &amp; Caicos Islands', 'Tuvalu', 'Uganda', 'Ukraine', 'United Arab Emirates', 'United Kingdom', 'U.S. Minor Outlying Is.', 'Uruguay', 'Uzbekistan', 'Vanuatu', 'Vatican (Holy See)', 'Venezuela', 'Viet Nam', 'Virgin Islands (British)', 'Virgin Islands (U.S.)', 'Wallis &amp; Futuna Is.', 'Western Sahara', 'Yemen', 'Yugoslavia', 'Zaire', 'Zambia', 'Zimbabwe'];

  formState = 'default';
  FeedBackGroup = this.fb.group({
    name: ['',
      [
        /* Validators.required,*/
        Validators.minLength(2),
        Validators.maxLength(150)
      ]
    ],
    country: ['',
      [
        Validators.required,
      ]
    ],
    preferredDay: [''],
    preferredTimeFrom: [''],
    preferredTimeTo: [''],
    topic: [''],
    message: ['',
      [
        Validators.minLength(2),
        Validators.maxLength(300)
      ]
    ],
    email: ['',
      [
        Validators.email,
        Validators.required,
        Validators.maxLength(150)
      ]
    ],
    phone: ['', [
      Validators.required,
      Validators.pattern(/^[0-9+-\\s]{5,22}$/)
    ]],

  });

  get key() {
    return this.FeedBackGroup.controls;
  }

  constructor(
    public nav: NavService,
    private fb: FormBuilder,
    private http: HttpClient,
    public loader: LoaderService) {

  }

  ngOnInit() {
    this.FeedBackGroup.controls.preferredDay.setValue('Any Day');
    this.FeedBackGroup.controls.preferredTimeFrom.setValue('11:00');
    this.FeedBackGroup.controls.preferredTimeTo.setValue('13:00');
    this.FeedBackGroup.controls.topic.setValue('General');
  }

  onSubmit() {
    // stop here if form is invalid
    if (this.FeedBackGroup.invalid) {
      return;
    }

    this.loader.show();
    const body = {
      name: this.key.name.value,
      email: this.key.email.value,
      phone: this.key.phone.value,
      country: this.key.country.value,
      preferredDay: this.key.preferredDay.value,
      preferredTimeFrom: this.key.preferredTimeFrom.value,
      preferredTimeTo: this.key.preferredTimeTo.value,
      topic: this.key.topic.value,
      message: this.key.message.value,
      formtype: 'SwissFS - Call Back'
    };
    this.http.post(this.nav.env.apiUrl + '/service/sendmail-api-callback.html', body)
      .pipe(map((res: any) => {
        if (res.errors) {throw new HttpErrorResponse({error: res.errors}); }
      }))
      .subscribe((response) => {
          this.loader.hide();
          this.formState = 'success';
          this.FeedBackGroup.reset();
        }, (error) => {
          this.loader.hide();
          this.formState = 'default';
          Object.keys(error.error).forEach(item => {
            if (this.key[item]){
              this.key[item].setErrors({serverError: error.error[item][0]});
            }
          });
        }
      );
  }

  getErrorName() {
    if (this.key.name.errors.required) {return $localize`:callbackForm|error name txt 1:You must enter a value`; }
    if (this.key.name.errors.minlength) {return $localize`:callbackForm|error name txt 2:This field can be more 2 characters long.`; }
    if (this.key.name.errors.maxlength) {return $localize`:callbackForm|error name txt 3:This field can be at most 150 characters long.`; }
    if (this.key.name.errors.serverError) {return this.key.phone.errors.serverError; }
  }
  getErrorEmail() {
    if (this.key.email.errors.required) {return $localize`:callbackForm|error email txt 1:An Email is required.`;    }
    if (this.key.email.errors.email) {return $localize`:callbackForm|error email txt 2:Please enter a valid email address.`;    }
    if (this.key.email.errors.maxlength) {return $localize`:callbackForm|error email txt 3:This field can be at most 150 characters long.`;    }
    if (this.key.email.errors.serverError) {return this.key.phone.errors.serverError; }
  }
  getErrorPhone() {
    if (this.key.phone.errors.required) {return $localize`:callbackForm|error phone txt 1:A phone is required.`;    }
    if (this.key.phone.errors.pattern) {return $localize`:callbackForm|error phone txt 2:That doesn‘t look like a valid phone.`;    }
    if (this.key.phone.errors.serverError) {return this.key.phone.errors.serverError; }
  }
  getErrorCountry() {
    if (this.key.country.errors.required) {return $localize`:callbackForm|error country txt 1:You must choose a country`; }
    if (this.key.country.errors.serverError) {return this.key.phone.errors.serverError; }
  }
  getErrorMessage() {
    if (this.key.message.errors.required) {return $localize`:callbackForm|error message txt 1:You must enter a value`;  }
    if (this.key.message.errors.minlength) {return $localize`:callbackForm|error message txt 2:This field can be more 2 characters long.`;  }
    if (this.key.message.errors.maxlength) {return $localize`:callbackForm|error message txt 3:This field can be at most 300 characters long.`;  }
    if (this.key.message.errors.serverError) {return this.key.phone.errors.serverError; }
  }

}
